export const CZECH_LANGUAGE_CODE = 'cs_CZ';
export const DUTCH_LANGUAGE_CODE = 'nl_NL';
export const ENGLISH_LANGUAGE_CODE = 'en_US';
export const FINNISH_LANGUAGE_CODE = 'fi_FI';
export const FRENCH_LANGUAGE_CODE = 'fr_FR';
export const GERMAN_LANGUAGE_CODE = 'de_DE';
export const ITALIAN_LANGUAGE_CODE = 'it_IT';
export const JAPANESE_LANGUAGE_CODE = 'ja_JP';
export const KOREAN_LANGUAGE_CODE = 'ko_KR';
export const NORWEGIAN_LANGUAGE_CODE = 'nb_NO';
export const POLISH_LANGUAGE_CODE = 'pl_PL';
export const PORTUGUESE_LANGUAGE_CODE = 'pt_BR';
export const SPANISH_LANGUAGE_CODE = 'es_ES';
export const SWEDISH_LANGUAGE_CODE = 'sv_SE';
export const RUSSIAN_LANGUAGE_CODE = 'ru_RU';
export const TRADITIONAL_CHINESE_LANGUAGE_CODE = 'zh_TW';
export const SIMPLIFIED_CHINESE_LANGUAGE_CODE = 'zh_CN';

export const DARK_MODE = 'dark';
export const LIGHT_MODE = 'light';

export const languageJSONList = {
  [CZECH_LANGUAGE_CODE]: {
    trade_mark:
      '*Všechny ochranné známky a názvy značek jsou majetkem příslušných vlastníků. Všechny názvy společností, produktů a služeb použité na tomto webu slouží pouze k identifikačním účelům. Použití těchto názvů, ochranných známek a značek neznamená jejich podporu. Používání těchto řešení třetích stran spadá pod Smluvní podmínky jejich příslušných vlastníků. Microsoft Teams® je ochranná známka skupiny společností Microsoft. Zoom® je ochranná známka společnosti Zoom Video Communications, Inc.',
    select_meeting: 'Vyberte řešení pro schůzky třetí strany*',
    join: 'Připojte se k ',
    microsoft_teams: 'Microsoft Teams',
    guest: ' Setkání (host)',
    login_to: 'Přihlaste se do',
    account: ' (Účet)',
    cisco_webex: 'cisco-webex',
    google_meet: 'Google setkat',
    zoom: 'zoom',
    hdmi_connected: 'Ujistěte se, že je připojeno video zařízení HDMI.'
  },
  [DUTCH_LANGUAGE_CODE]: {
    trade_mark:
      '*Alle handelsmerken en merknamen zijn het eigendom van hun respectieve eigenaars. Alle bedrijfs-, product- en servicenamen die op deze website worden gebruikt, zijn alleen voor identificatiedoeleinden. Het gebruik van deze namen, handelsmerken en merken impliceert geen goedkeuring. Het gebruik van deze oplossingen van derden valt onder de algemene voorwaarden van hun respectievelijke eigenaren. Microsoft Teams® is een handelsmerk van de Microsoft-bedrijvengroep. Zoom® is een handelsmerk van Zoom Video Communications, Inc.',
    select_meeting: 'Selecteer een vergaderoplossing van derden*',
    join: 'Sluit je aan bij',
    microsoft_teams: 'Microsoft Teams',
    guest: ' Vergadering (Gast)',
    login_to: 'Log in op',
    account: ' (Rekening)',
    cisco_webex: 'Cisco webex',
    google_meet: 'Google ontmoeten',
    zoom: 'Zoom',
    hdmi_connected: 'Controleer of het HDMI-videoapparaat is aangesloten.'
  },
  [ENGLISH_LANGUAGE_CODE]: {
    trade_mark:
      '*All trademarks and brand names are the property of their respective owners. All company, product, and service names used in this website are for identification purposes only. Use of these names, trademarks, and brands do not imply endorsement. Use of these third-party solutions falls under the Term and Conditions of their respective owners. Microsoft Teams® is a trademark of the Microsoft group of companies. Zoom® is a trademark of Zoom Video Communications, Inc.',
    select_meeting: 'Select a Third-Party Meeting Solution*',
    join: 'Join',
    microsoft_teams: 'Microsoft Teams',
    guest: 'Meeting (Guest)',
    login_to: 'Login to',
    account: '(Account)',
    cisco_webex: 'Cisco Webex',
    google_meet: 'Google Meet',
    zoom: 'Zoom',
    hdmi_connected: 'Please make sure that the HDMI video device is connected.'
  },
  [FINNISH_LANGUAGE_CODE]: {
    trade_mark:
      '*Kaikki tavaramerkit ja tuotenimet ovat omistajiensa omaisuutta. Kaikki tällä sivustolla käytetyt yritysten, tuotteiden ja palvelujen nimet ovat vain tunnistamistarkoituksiin. Näiden nimien, tavaramerkkien ja tuotemerkkien käyttö ei tarkoita hyväksyntää. Näiden kolmannen osapuolen ratkaisujen käyttö on niiden omistajien ehtojen alaista. Microsoft Teams® on Microsoft-yritysryhmän tavaramerkki. Zoom® on Zoom Video Communications, Inc:n tavaramerkki.',
    select_meeting: 'Valitse kolmannen osapuolen kokousratkaisu*',
    join: 'Liity',
    microsoft_teams: 'Microsoft Teamsiin',
    guest: 'Kokous (vieras)',
    login_to: 'Kirjaudu',
    account: '(Tili)',
    cisco_webex: 'Cisco WebEx',
    google_meet: 'Google tapaa',
    zoom: 'zoomaus',
    hdmi_connected: 'Varmista, että HDMI-videolaite on kytketty.'
  },
  [FRENCH_LANGUAGE_CODE]: {
    trade_mark:
      "*Toutes les marques et noms de marque sont la propriété de leurs propriétaires respectifs. Tous les noms de sociétés, de produits et de services utilisés sur ce site Web sont uniquement à des fins d'identification. L'utilisation de ces noms, marques et marques n'implique pas leur approbation. L'utilisation de ces solutions tierces relève des conditions générales de leurs propriétaires respectifs. Microsoft Teams® est une marque commerciale du groupe de sociétés Microsoft. Zoom® est une marque commerciale de Zoom Video Communications, Inc.",
    select_meeting: 'Sélectionnez une solution de réunion tierce*',
    join: 'Réunion Microsoft Teams',
    microsoft_teams: '',
    guest: '',
    login_to: 'Compte Microsoft 365',
    account: '',
    cisco_webex: 'Cisco webex',
    google_meet: 'Google Meet',
    zoom: 'Zoom',
    hdmi_connected: 'Impossible de lancer la présentation, veuillez vérifier la connexion HDMI'
  },
  [GERMAN_LANGUAGE_CODE]: {
    trade_mark:
      '*Alle Warenzeichen und Markennamen sind Eigentum ihrer jeweiligen Besitzer. Alle auf dieser Website verwendeten Firmen-, Produkt- und Dienstleistungsnamen dienen nur zu Identifikationszwecken. Die Verwendung dieser Namen, Warenzeichen und Marken impliziert keine Billigung. Die Nutzung dieser Lösungen von Drittanbietern fällt unter die Nutzungsbedingungen ihrer jeweiligen Eigentümer. Microsoft Teams® ist eine Marke der Microsoft-Unternehmensgruppe. Zoom® ist eine Marke von Zoom Video Communications, Inc.',
    select_meeting: 'Wählen Sie eine Meeting-Lösung eines Drittanbieters*',
    join: 'Treten Sie Microsoft Teams bei',
    microsoft_teams: '',
    guest: 'Treffen (Gast)',
    login_to: 'Melden Sie sich bei Microsoft Teams an',
    account: '(Konto)',
    cisco_webex: 'Cisco WebEx',
    google_meet: 'Google Meet',
    zoom: 'Zoom',
    hdmi_connected: 'Bitte stellen Sie sicher, dass das HDMI-Videogerät angeschlossen ist'
  },
  [ITALIAN_LANGUAGE_CODE]: {
    trade_mark:
      "*Tutti i marchi e nomi di marchi sono di proprietà dei rispettivi proprietari. Tutti i nomi di società, prodotti e servizi utilizzati in questo sito Web sono solo a scopo identificativo. L'uso di questi nomi, marchi e marchi non implica l'approvazione. L'uso di queste soluzioni di terze parti rientra nei termini e nelle condizioni dei rispettivi proprietari. Microsoft Teams® è un marchio del gruppo di società Microsoft. Zoom® è un marchio di Zoom Video Communications, Inc.",
    select_meeting: 'Seleziona una soluzione per riunioni di terze parti*',
    join: 'Partecipa ad un meeting',
    microsoft_teams: 'Microsoft Teams',
    guest: '(ospite)',
    login_to: 'Accedi a',
    account: '(Account)',
    cisco_webex: 'Cisco webex',
    google_meet: 'Google Meet',
    zoom: 'Zoom',
    hdmi_connected: 'Assicurarsi che il dispositivo video HDMI sia collegato'
  },
  [JAPANESE_LANGUAGE_CODE]: {
    trade_mark:
      '*すべての商標およびブランド名は、それぞれの所有者の財産です。 この Web サイトで使用されているすべての会社名、製品名、およびサービス名は、識別のみを目的としています。 これらの名前、商標、およびブランドの使用は、承認を意味するものではありません。 これらのサードパーティ ソリューションの使用は、それぞれの所有者の契約条件に該当します。 Microsoft Teams® は、Microsoft グループ企業の商標です。 Zoom® は、Zoom Video Communications, Inc. の商標です。',
    select_meeting: 'サードパーティの会議ソリューションを選択してください*',
    join: 'Microsoft Teams に参加する',
    microsoft_teams: '',
    guest: ' ミーティング（ゲスト）',
    login_to: 'Microsoft Teams にログインする',
    account: '(アカウント）',
    cisco_webex: 'cisco-webex',
    google_meet: 'Google Meet',
    zoom: 'Zoom',
    hdmi_connected: 'HDMIビデオ機器が接続されていることを確認してください。'
  },
  [KOREAN_LANGUAGE_CODE]: {
    trade_mark:
      '*모든 상표 및 브랜드 이름은 해당 소유자의 재산입니다. 이 웹사이트에 사용된 모든 회사, 제품 및 서비스 이름은 식별 목적으로만 사용됩니다. 이러한 이름, 상표 및 브랜드를 사용한다고 해서 보증을 의미하지는 않습니다. 이러한 타사 솔루션의 사용은 해당 소유자의 이용 약관에 따릅니다. Microsoft Teams®는 Microsoft 그룹 회사의 상표입니다. Zoom®은 Zoom Video Communications, Inc.의 상표입니다.',
    select_meeting: '타사 회의 솔루션 선택*',
    join: 'Microsoft 팀에 가입',
    microsoft_teams: '',
    guest: ' 회의(손님)',
    login_to: 'Microsoft 팀에 로그인',
    account: '(계정)',
    cisco_webex: '시스코 웹엑스',
    google_meet: '구글 미팅',
    zoom: '줌',
    hdmi_connected: 'HDMI 비디오 장치가 연결되어 있는지 확인하세요.'
  },
  [NORWEGIAN_LANGUAGE_CODE]: {
    trade_mark:
      '*Alle varemerker og merkenavn tilhører sine respektive eiere. Alle firma-, produkt- og tjenestenavn som brukes på denne nettsiden er kun for identifikasjonsformål. Bruk av disse navnene, varemerkene og merkene innebærer ikke godkjenning. Bruk av disse tredjepartsløsningene faller inn under vilkårene og betingelsene til deres respektive eiere. Microsoft Teams® er et varemerke for Microsoft-gruppen av selskaper. Zoom® er et varemerke for Zoom Video Communications, Inc.',
    select_meeting: 'Velg en tredjeparts møteløsning*',
    join: 'Bli med i',
    microsoft_teams: 'Microsoft Teams',
    guest: 'Møte (gjest)',
    login_to: 'Logg på',
    account: '(Regnskap)',
    cisco_webex: 'cisco-webex',
    google_meet: 'Google møtes',
    zoom: 'Zoom',
    hdmi_connected: 'Kontroller at HDMI-videoenheten er tilkoblet.'
  },
  [POLISH_LANGUAGE_CODE]: {
    trade_mark:
      '*Wszystkie znaki towarowe i nazwy marek są własnością ich właścicieli. Wszystkie nazwy firm, produktów i usług użyte na tej stronie służą wyłącznie celom identyfikacyjnym. Użycie tych nazw, znaków towarowych i marek nie oznacza poparcia. Korzystanie z tych rozwiązań stron trzecich podlega Warunkom ich odpowiednich właścicieli. Microsoft Teams® jest znakiem towarowym grupy firm Microsoft. Zoom® jest znakiem towarowym firmy Zoom Video Communications, Inc.',
    select_meeting: 'Wybierz rozwiązanie do spotkań innej firmy*',
    join: 'Dołącz do zespołów Microsoft',
    microsoft_teams: '',
    guest: 'Spotkanie (gość)',
    login_to: 'Zaloguj się do Microsoft Teams',
    account: '(Rachunek)',
    cisco_webex: 'Cisco WebEx',
    google_meet: 'Google Meet',
    zoom: 'Powiększenie',
    hdmi_connected: 'Upewnij się, że urządzenie wideo HDMI jest podłączone'
  },
  [PORTUGUESE_LANGUAGE_CODE]: {
    trade_mark:
      '*Todas as marcas registradas e nomes de marcas são de propriedade de seus respectivos proprietários. Todos os nomes de empresas, produtos e serviços usados ​​neste site são apenas para fins de identificação. O uso desses nomes, marcas registradas e marcas não implica endosso. O uso dessas soluções de terceiros se enquadra nos Termos e Condições de seus respectivos proprietários. Microsoft Teams® é uma marca registrada do grupo de empresas Microsoft. Zoom® é uma marca comercial da Zoom Video Communications, Inc.',
    select_meeting: 'Selecione uma solução de reunião de terceiros*',
    join: 'Junte-se às',
    microsoft_teams: 'equipes da Microsoft',
    guest: 'Reunião (Convidado)',
    login_to: 'Faça login no',
    account: '(Conta)',
    cisco_webex: 'Cisco webex',
    google_meet: 'Google Conheça',
    zoom: 'Zoom',
    hdmi_connected: 'Certifique-se de que o dispositivo de vídeo HDMI está ligado'
  },
  [SPANISH_LANGUAGE_CODE]: {
    trade_mark:
      '*Todas las marcas registradas y los nombres de marcas son propiedad de sus respectivos dueños. Todos los nombres de empresas, productos y servicios utilizados en este sitio web tienen únicamente fines de identificación. El uso de estos nombres, marcas registradas y marcas no implica aprobación. El uso de estas soluciones de terceros se rige por los Términos y condiciones de sus respectivos propietarios. Microsoft Teams® es una marca comercial del grupo de empresas Microsoft. Zoom® es una marca comercial de Zoom Video Communications, Inc.',
    select_meeting: 'Seleccione una solución de reuniones de terceros*',
    join: 'Unirse a una reunión de',
    microsoft_teams: 'Microsoft Teams',
    guest: '(invitado)',
    login_to: 'Iniciar sesión en',
    account: '(cuenta)',
    cisco_webex: 'Cisco webex',
    google_meet: 'Google Meet',
    zoom: 'Zoom',
    hdmi_connected: 'Asegúrese de que el dispositivo de vídeo HDMI está conectado'
  },
  [SWEDISH_LANGUAGE_CODE]: {
    trade_mark:
      '*Alla varumärken och varumärken tillhör sina respektive ägare. Alla företags-, produkt- och tjänstnamn som används på denna webbplats är endast för identifieringsändamål. Användning av dessa namn, varumärken och varumärken innebär inte stöd. Användning av dessa tredjepartslösningar faller under deras respektive ägares villkor. Microsoft Teams® är ett varumärke som tillhör Microsoft-koncernen. Zoom® är ett varumärke som tillhör Zoom Video Communications, Inc.',
    select_meeting: 'Välj en möteslösning för tredje part*',
    join: 'Gå med i',
    microsoft_teams: 'Microsoft Teams',
    guest: 'Möte (gäst)',
    login_to: 'Logga in på',
    account: '(Konto)',
    cisco_webex: 'Cisco WebEx',
    google_meet: 'Google träffas',
    zoom: 'Zoom',
    hdmi_connected: 'Kontrollera att HDMI-videoenheten är ansluten'
  },
  [RUSSIAN_LANGUAGE_CODE]: {
    trade_mark:
      '*All trademarks and brand names are the property of their respective owners. All company, product, and service names used in this website are for identification purposes only. Use of these names, trademarks, and brands do not imply endorsement. Use of these third-party solutions falls under the Term and Conditions of their respective owners. Microsoft Teams® is a trademark of the Microsoft group of companies. Zoom® is a trademark of Zoom Video Communications, Inc.',
    select_meeting: 'Select a Third-Party Meeting Solution*',
    join: 'Join',
    microsoft_teams: 'Microsoft Teams',
    guest: 'Meeting (Guest)',
    login_to: 'Login to',
    account: '(Account)',
    cisco_webex: 'Cisco Webex',
    google_meet: 'Google Meet',
    zoom: 'Zoom',
    hdmi_connected: 'Убедитесь, что видеоустройство HDMI подключено'
  },
  [TRADITIONAL_CHINESE_LANGUAGE_CODE]: {
    trade_mark:
      '*All trademarks and brand names are the property of their respective owners. All company, product, and service names used in this website are for identification purposes only. Use of these names, trademarks, and brands do not imply endorsement. Use of these third-party solutions falls under the Term and Conditions of their respective owners. Microsoft Teams® is a trademark of the Microsoft group of companies. Zoom® is a trademark of Zoom Video Communications, Inc.',
    select_meeting: 'Select a Third-Party Meeting Solution*',
    join: 'Join',
    microsoft_teams: 'Microsoft Teams',
    guest: 'Meeting (Guest)',
    login_to: 'Login to',
    account: '(Account)',
    cisco_webex: 'Cisco Webex',
    google_meet: 'Google Meet',
    zoom: 'Zoom',
    hdmi_connected: '請確保已連接 HDMI 視訊設備'
  },
  [SIMPLIFIED_CHINESE_LANGUAGE_CODE]: {
    trade_mark:
      '*All trademarks and brand names are the property of their respective owners. All company, product, and service names used in this website are for identification purposes only. Use of these names, trademarks, and brands do not imply endorsement. Use of these third-party solutions falls under the Term and Conditions of their respective owners. Microsoft Teams® is a trademark of the Microsoft group of companies. Zoom® is a trademark of Zoom Video Communications, Inc.',
    select_meeting: 'Select a Third-Party Meeting Solution*',
    join: 'Join',
    microsoft_teams: 'Microsoft Teams',
    guest: 'Meeting (Guest)',
    login_to: 'Login to',
    account: '(Account)',
    cisco_webex: 'Cisco Webex',
    google_meet: 'Google Meet',
    zoom: 'Zoom',
    hdmi_connected: '请确保已连接 HDMI 视频设备'
  }
};
